export default "__VITE_ASSET__DmHYv$JQ__"